import { END_POINT } from 'constants/Api';
import api from './Instance';
import { makeApiUri } from 'utils/Utils';
import { TMember } from 'types/TMember';

export const getMemberById = async (memberId: number) => {
    return await api.get<TMember>(`${makeApiUri(END_POINT.MEMBER)}/${memberId}`);
};
